import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DangerModalComponent } from '../../../shared/components/danger-modal/danger-modal.component';
import { SuccessModalComponent } from '../../../shared/components/success-modal/success-modal.component';
import { PreventiveMaintenanceService } from '../preventive-maintenance.service';

@Component({
  selector: 'app-preventive-maintenance-pdf-add',
  templateUrl: './preventive-maintenance-pdf-add.component.html',
  styleUrls: ['./preventive-maintenance-pdf-add.component.css']
})
export class PreventiveMaintenancePdfAddComponent implements OnInit {
  form = this.fb.group({
    fileId: [null, [Validators.required]],
    fileName: ['', [Validators.required]],
    description: [null]
  });

  equipmentId: string;
  pmId: string;
  bsModalRef: BsModalRef;
  photos = new FormData();

  constructor(private modalService: BsModalService, private route: ActivatedRoute, private fb: FormBuilder, private router: Router, 
    private pmService: PreventiveMaintenanceService, private translate: TranslateService) {

    this.route.params.subscribe(params => {
      this.equipmentId = params.equipmentId;
      this.pmId = params.pmId;
      console.log(params);
      
    });
  }
  ngOnInit() {
  }

  submit(){
    console.log(this.form.value);
    this.pmService.createPMPdf(this.pmId, this.equipmentId, this.form.value.description ,this.photos).subscribe(x=>{
      const initialState = {
        message: this.translate.instant('header.pdf'),
        ok: () => {
          this.router.navigate(['../'], { relativeTo: this.route });
          this.bsModalRef.hide();
        }
      };
      this.bsModalRef = this.modalService.show(SuccessModalComponent, { initialState });
    }, err => {
      console.log(err);
      const initialState = {
        
        message: err.error.message || this.translate.instant('msg.error'),
        ok: () => {
          this.bsModalRef.hide();
        }
      };
      this.bsModalRef = this.modalService.show(DangerModalComponent, {initialState})
    });

  }
  public closeSuccessModel(): void {
    this.router.navigate([['/home/preventive-maintenance/pdf', this.pmId, this.equipmentId]]);
  }
  onFileChange(event) {

    if (event.target.files && event.target.files.length) {
      this.photos.append(`specialForm`, event.target.files[0]);
      console.log(event.target.files);      
      console.log(event.target.files[0].name);
      this.form.patchValue({
        fileName: event.target.files[0].name,
        fileId: [0]
      })
      // this.pmService.uploadFile(event.target.files[0]).subscribe(res => {
      //   console.log(res);
      //   this.form.patchValue({
      //     fileName: res.files[0].fileName,
      //     fileId: [res.files[0].fileId]
      //   })
      // })
    } else {

    }
  }
  removeFile() {
    this.form.patchValue({
      fileName: null,
      fileId: null,
    })
  }

} 



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-pdf-add/preventive-maintenance-pdf-add.component.ts